<template>
  <div class="">
    <div class="container">
      <h2 class="header-font text-center">About the Company</h2>
      <div class="grid">
        <div class="img">
          <img :src="instructorData.avatar" alt="" />
        </div>
        <div class="text">
          <br />
          <p>
            {{ instructorData.info }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instructorData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      readmore: false,
    }
  },
  methods: {
    red() {
      this.readmore = !this.readmore
      this.$refs.btnToggle.innerText = this.readmore ? 'Hide More' : 'Show More'
    },
  },
}
</script>

<style scoped>
.btn-1 {
  background-color: white;
  border: none;
  color: #2465f3;
  padding: 7px 30px;
  cursor: pointer;
  font-size: 16px;
  font-family: 'Manrope';
  font-weight: 700;
}
.span-h2 {
  padding-top: 20px;
  font: 700 1.5rem/1rem 'Manrope';
  color: white;
}
.span-h4 {
  padding: 20px 0;
  font: 400 0.75rem / auto 'Manrope';
  color: white;
}
.img img {
  margin: 65px 130px;
  border: none;
}
.grid {
  max-width: 1300px;
  margin: 0 auto;
  background-color: #d21e28;

  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
}
.header-font {
  padding-top: 70px;
  font: 800 2.25rem/2.75rem 'Manrope';
  color: #29292b;
  padding-bottom: 50px;
}
.text {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.text h3 {
  font: 700 2.5rem/1.75rem 'Manrope';
  color: white;
}
.text h4 {
  font: 400 0.75rem/1.2rem 'Manrope';
  color: #ececec;
}
.text p {
  font: 400 1.25rem/1.3rem 'Manrope';
  color: white;
  width: 480px;
  font-size: 12px;
}
ul li {
  font: 400 0.875rem/1rem 'Manrope';
  color: #d7eefd;
}
@media only screen and (max-width: 600px) {
  .img img {
    display: flex;
    margin: 25px auto;
    border: none;
  }
  .grid {
    max-width: 1300px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    grid-template-columns: 1fr;
  }
  .text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 40px;
  }
  .text p {
    font: 400 0.875rem/1.1rem 'Manrope';
    color: white;
    max-width: 300px;
    font-size: 12px;
    word-break: keep-all;
  }
}
</style>
